import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/beeswarm/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/beeswarm/';

class BeeswarmService {

  getBeeswarm(playerSeasonInfoId, radarId, seasonIds) {
    return axios.get(
      API_URL + 'player-season-info/' + playerSeasonInfoId + '/radar/' + radarId +  '/compare-seasons/' + seasonIds
    )
    .then((response) => {
      return response.data;

    })
  }

  getBeeswarmByCategory(playerSeasonInfoId, radarId, categoryId, seasonIds) {
    return axios.get(
      API_URL + 'player-season-info/' + playerSeasonInfoId + '/radar/' + radarId + '/category/' + categoryId + '/compare-seasons/' + seasonIds
    )
    .then((response) => {
      return response.data;

    })
  }

  getTeamBeeswarm(teamId, seasonId, stat, compareSeasonIds) {
    return axios.get(
      API_URL + 'team/' + teamId + '/season/' + seasonId + '/stat/' + stat + '/compare-seasons/' + compareSeasonIds
    )
    .then((response) => {
      return response.data;

    })
  }

}

export default new BeeswarmService();



// WEBPACK FOOTER //
// ./src/services/beeswarm.service.js